import React from 'react';
import { useLocation } from 'react-router-dom';
import ProductsNavMenu from '../LandingPage/products/ProductsNavMenu';
import '../LandingPage/products/ProductsPage.css';

function resolveProductsNavActive(pathname) {
  if (pathname.startsWith('/docs')) return 'docs';
  if (pathname.startsWith('/products')) return 'products';
  return '';
}

/**
 * Products / Documentation launcher shown before each app shell sidebar menu.
 */
export default function ShellHeaderProductsNav() {
  const { pathname } = useLocation();
  const activeNav = resolveProductsNavActive(pathname);

  return (
    <div className="shell-header-products-nav">
      <ProductsNavMenu activeNav={activeNav} />
    </div>
  );
}
